import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-circle-check',
  templateUrl: './icon-circle-check.component.html',
  styles: []
})
export class IconCircleCheckComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
